import _ from 'lodash';

import { COLUMN_MIN_WIDTH, FIRST_COLUMN_MIN_WIDTH } from './simple-table.constants';
import { ColumnMinWidths } from './simple-table.types';

interface ISpannableRow {
  cells: Array<{ colSpan?: number }>;
}

// The widest header row, counting spanned columns — the column count every body row is laid out against.
export const countColumns = (headerRows: ISpannableRow[]): number =>
  _.max(headerRows.map((row) => _.sumBy(row.cells, (cell) => cell.colSpan ?? 1))) ?? 0;

// `true` floors the first column wider than the rest, `{ first, rest }` overrides either default, and an
// explicit array is index-aligned with the columns.
export const resolveColumnMinWidths = (columnMinWidths: ColumnMinWidths | undefined, columnCount: number): number[] | undefined => {
  if (Array.isArray(columnMinWidths)) return columnMinWidths;
  if (!columnMinWidths) return undefined;
  const { first = FIRST_COLUMN_MIN_WIDTH, rest = COLUMN_MIN_WIDTH } = columnMinWidths === true ? {} : columnMinWidths;
  return _.times(columnCount, (index) => (index === 0 ? first : rest));
};
